import React, { Component } from "react";
import { Link } from "react-router-dom";
// import page parts
import Published from "./projects/published";
import UnPublished from "./projects/unpublished";
// styles for page
import "./dashboard.css";
// images for page
import Empty from "../../assets/images/empty.png";
import Loader from "../../assets/images/loader.svg";
import Logo from "../../assets/images/logo.png";
import Chat from "../../assets/images/chat.svg";
import Avatar from "../../assets/images/avatar.svg";
// icons for page
import Ionicon from "react-ionicons";
import Grow from "@material-ui/core/Grow";

export default class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      published: [],
      unpublished: [],
      // subdomain popup
      subPopup: false,
      subdomain: null,
      subdomainValid: null,
      subdomainTypeLoader: false,
      subdomainRegistered: false,
      inRequest: true,
      projectState: false,
      menuState: false,
      noResult: false
    };
    this.unpubClone = [];
    this.pubClone = [];
    this.token = window.localStorage.getItem("token");
    this.authToken = window.localStorage.getItem("authToken");
    //  on type timer
    this.timer = null;
    this.typeDelay = 800;
  }
  componentDidMount = () => {
    document.body.style.backgroundColor = "#f5f5f5";
    this.set();
  };
  componentWillUnmount = () => {
    document.body.style.backgroundColor = "#ffffff";
  };
  // manipulate project loading
  set = () => {
    window.setTimeout(() => this.setState({ inRequest: false }), 1000);
  };
  // logout function
  logOut = () => {
    window.localStorage.clear();
    window.location.assign("/login");
  };

  handleSearch = event => {
    event.preventDefault();
    // initializze
    let keyword = event.target.value;
    let SearchListUnPub = [];
    let SearchListPub = [];
    // searching in unpublished project list
    this.state.unpublished.map((item, index) => {
      if (item.subdomain.includes(keyword)) {
        SearchListUnPub.push(item);
      }
    });
    // searching in published project list
    this.state.published.map((item, index) => {
      if (item.subdomain.includes(keyword)) {
        SearchListPub.push(item);
      }
    });
    // check query length for hide/show result
    if (keyword.length !== 0) {
      if (SearchListUnPub.length > 0) {
        this.changeArrayState("unpublished", SearchListUnPub);
      } else if (SearchListUnPub.length === 0) {
        this.changeArrayState("unpublished", []);
        console.log(" 0 length unpub");
      }
      if (SearchListPub.length > 0) {
        this.changeArrayState("published", SearchListPub);
      } else if (SearchListPub.length === 0) {
        this.changeArrayState("published", []);
        console.log(" 0 length pub");
      }
    } else if (keyword.length === 0) {
      {
        this.changeArrayState("published", this.pubClone);
        this.changeArrayState("unpublished", this.unpubClone);
      }
    }
    if (SearchListPub.length === 0 && SearchListUnPub.length === 0) {
      this.setState({
        noResult: true
      });
    } else {
      this.setState({
        noResult: false
      });
    }
  };
  // check if bacspace or delete pressed //reset list for search
  getKey = event => {
    let key = event.keyCode || event.charCode;
    if (key === 8 || key === 46)
      this.setState({
        published: this.pubClone,
        unpublished: this.unpubClone
      });
  };
  // get word charachters in array
  getCharArray = str => {
    let keyArray = [];
    for (let i = 0; i < str.length; i++) {
      keyArray.push(str[i]);
    }
    return keyArray;
  };

  // set array to state
  changeArrayState = (st, arr) => {
    this.setState({
      [st]: arr
    });
  };
  // open/close subdomain popup
  togglePopup = () => {
    this.setState({
      subPopup: !this.state.subPopup,
      subdomainValid: null,
      subdomain: null
    });
  };
  // open/close menu
  toggleMenu = () => {
    this.setState({
      menuState: !this.state.menuState
    });
  };
  // set state on field value change
  handleChange = event => {
    let name = event.target.name;
    let value = event.target.value;
    this.setState(
      {
        [name]: value,
        subdomainRegistered: false,
        // values for validate
        fieldToValidateName: name,
        fieldToValidateValue: value
      },
      this.timerLoader(name)
    );
  };
  // delay on field type,show/hide loader
  timerLoader = n => {
    // reset timer
    window.clearTimeout(this.timer);
    // turn on loader ,turn off validation
    this.setState({
      [n + "TypeLoader"]: true,
      [n + "Valid"]: null
    });
    // turn off loader
    setTimeout(() => {
      this.setState({ [n + "TypeLoader"]: false });
    }, 400);
    // // after delay, callback validation function
    this.timer = setTimeout(() => {
      this.checkSubdomainValid();
    }, this.typeDelay);
  };
  // check subdomain validation
  checkSubdomainValid = () => {
    let subdomainLength = this.state.subdomain.length;
    if (subdomainLength < 8 && subdomainLength > 1) {
      this.setState({
        subdomainValid: true
      });
    } else if (subdomainLength < 8 || subdomainLength > 1) {
      this.setState({
        subdomainValid: false
      });
    }
  };
  // on subdomain confirm open constructor page
  handleBuilder = e => {
    e.preventDefault();
    window.location.assign(`/project_register`);
    window.localStorage.setItem("subdomain", this.state.subdomain);
  };
  // /large search field on focus

  render() {
    console.log(this.state.projectState);
    const LoaderView = (
      <div className="subOverlay perfectCenter">
        <img src={Loader} />
      </div>
    );
    if (this.state.inRequest) {
      return LoaderView;
    }
    let pub = this.state.published;
    let unPub = this.state.unpublished;

    const projHTML = (
      <div className="noProject perfectCenter">
        <img src={Empty} />
        <h1>There isn’t any Project here, yet.</h1>
        <h2>Wanna create one?</h2>
        <button className="buttonMid perfectCenter" onClick={this.togglePopup}>
          <span>Yes, Create Now</span>
        </button>
      </div>
    );
    const noResult = (
      <div className="noProject perfectCenter">
        <img src={Empty} />
        <h1>There are no results that match your search</h1>
      </div>
    );

    const searchBody = (
      <div className="searchBody">
        <label>
          <input
            type="text"
            placeholder="search"
            onChange={this.handleSearch}
            onKeyDown={this.getKey}
            spellCheck={false}
          />
          <Ionicon
            icon="ios-search"
            fontSize="30px"
            color="#323b43"
            className="searchAbs"
          />
        </label>
      </div>
    );
    let alertIcon = null;
    if (this.state.subdomainValid !== null) {
      if (this.state.subdomainValid) {
        alertIcon = (
          <Ionicon
            icon="ios-checkmark"
            fontSize="50px"
            color="#36c547"
            className="typeLoader"
          />
        );
      } else {
        alertIcon = (
          <Ionicon
            icon="ios-close"
            fontSize="50px"
            color="#f50c3d"
            className="typeLoader"
          />
        );
      }
    }

    const subPopup = (
      <React.Fragment>
        <div className="overlayParent" />
        <div className="subOverlay perfectCenter">
          <form className="subForm perfectCenter">
            <div className="formHeading">Choose Your URL</div>
            <Ionicon
              icon="md-close"
              fontSize="40px"
              color="rgba(50, 59, 67, 0.7)"
              className="closePopup"
              onClick={this.togglePopup}
            />
            <div className="subdomainArea">
              <input
                type="text"
                maxLength="15"
                size="4"
                placeholder="projectname"
                required
                name="subdomain"
                value={this.state.subdomain}
                onChange={this.handleChange}
              />

              <label className="subPath">
                <input value=".com" disabled />
                <div className="perfectCenter loaderElement">
                  {this.state.subdomainTypeLoader ? (
                    <span className="typeLoader perfectCenter">
                      <img src={Loader} />
                    </span>
                  ) : (
                    alertIcon
                  )}
                </div>
                {this.state.subdomainRegistered && (
                  <div className="authMessage absBottom">
                    Already Registered
                  </div>
                )}
              </label>
            </div>
            <div className="subButton">
              <button
                className="buttonMid"
                disabled={!this.state.subdomainValid}
                onClick={this.handleBuilder}
              >
                <span>CREATE NOW</span>
              </button>
            </div>

            <p>You can change the URL later before publishing</p>
          </form>
        </div>
      </React.Fragment>
    );

    // search body,create button show/hide
    let searchBodyState, noProjects;
    if (!this.state.projectState) {
      searchBodyState = null;
      noProjects = projHTML;
    } else if (this.state.projectState) {
      noProjects = null;
      searchBodyState = searchBody;
    }

    console.log("pub=" + pub.length);
    console.log("unpub=" + unPub.length);

    return (
      <React.Fragment>
        <div className="dashboard">
          <div className="dashboardHeader">
            <div className="dashboardHeaderLeft">
              <Link to="/" className="homeLink perfectCenter">
                <img src={Logo} onClick={this.props.HandleClick} />
              </Link>
              <div className="dashboardMenu perfectCenter">
                <Ionicon icon="md-apps" fontSize="31px" color="#ffffff" />
                Dashboard
              </div>
            </div>
            <div className="dashboardHeaderRight">
              <div
                className="profileSettings perfectCenter"
                onClick={this.toggleMenu}
                onBlur={() => alert("ok")}
              >
                <div className="profileName">USERNAME</div>
                <div className="profileImage">
                  <img src={Avatar} />
                  <Ionicon
                    icon="md-arrow-dropdown"
                    // fontSize="15.5px"
                    color="#ffffff"
                    className="imageAsset"
                  />
                </div>
                {this.state.menuState && (
                  <Grow in={this.state.menuState}>
                    <div className="dropDownMenu">
                      <ul className="profileMenu">
                        <li>
                          <span>Settings</span>
                          <Ionicon
                            icon="md-settings"
                            fontSize="20px"
                            color="#ffffff"
                            className="menuIcon"
                          />
                        </li>
                        <li>
                          <span>Something</span>
                          <Ionicon
                            icon="md-plane"
                            fontSize="20px"
                            color="#ffffff"
                            className="menuIcon"
                          />
                        </li>
                        <li onClick={this.logOut}>
                          <span>Log out</span>
                          <Ionicon
                            icon="md-log-out"
                            fontSize="20px"
                            color="#ffffff"
                            className="menuIcon"
                          />
                        </li>
                      </ul>
                    </div>
                  </Grow>
                )}
              </div>
            </div>
          </div>
          <div className="dashboardBody ">
            {searchBodyState}
            {pub.length > 0 ? (
              <Published projCount={pub.length} projectList={pub} />
            ) : null}
            {unPub.length > 0 ? (
              <UnPublished
                projCount={unPub.length}
                projectList={unPub}
                toggle={this.togglePopup}
              />
            ) : null}
            {noProjects}
            {this.state.noResult && noResult}
          </div>
          <div className="dashboardChat">
            <img src={Chat} />
          </div>
          {this.state.subPopup ? subPopup : null}
        </div>
      </React.Fragment>
    );
  }
}
